export default __webpack_public_path__ + "static/media/haus.1e731f79.jpg";